import React from 'react';

const Contact = () => {
    return (
        <section className="shared-container pt-5">
            <div className="container p-5" id="contact">
                <div className="row">

                    <div className="col-md-6">
                        <h1 style={{ fontWeight: 'bold' }}>Let us handle your <br /> project, professionally. </h1>
                        <p className="text-secondary">Our target is to satisfy our clients with professionalism, dedication, sincerity, flexibility and on-time delivery.</p>
                    </div>

                    <div className="col-md-6">
                        <form action="">
                            <div className="form-group">
                                <input type="text" className="form-control" placeholder="Your Email Address *" />
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control" placeholder="Your name / company's name *" />
                            </div>
                            <div className="form-group">
                                <textarea name="" className="form-control" id="" cols="30" rows="10" placeholder="Your Message *"></textarea>
                            </div>
                            <div className="form-group">
                                <button type="button" className="btn btn-brand"> Submit </button>
                            </div>
                        </form>
                    </div>
                </div>


                <div className="container text-center text-muted mt-5 pt-5">
                    <p style={{ fontWeight: 'bold' }}>© Copyright Md. Touhedul Haque {(new Date()).getFullYear()} All Rights Reserved &#128640;. Zürich, Switzerland. </p>
                </div>

            </div>

        </section>

    );
};

export default Contact;